import * as Yup from "yup";

export const CreateSchema = Yup.object().shape({
  name: Yup.string().required("Please enter a name"),
});
